import { Button, message, Modal, Popover, Progress, Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { memo, useEffect, useState } from "react";
import { FaTrash } from "react-icons/fa6";
import { RxAvatar } from "react-icons/rx";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import { Organization_GetOne_Response, OrganizationAPIs } from "~/common/typescript/apis/OrganizationAPIs";
import UserAvatar from "~/layouts/components/Header/components/UserAvatar/UserAvatar";
import OrganizationRoleTag from "~/components/app_common/OrganizationRoleTag/OrganizationRoleTag";
import FormInviteMember from "../FormInviteMember/FormInviteMember";
import OrgInvitationList from "./components/OrgInvitationList";

const OrgMemberList = () => {
  const { organizationID } = useParams();
  const [organization, setOrganization] = useState<Organization_GetOne_Response>();
  const fetchData = async () => {
    OrganizationAPIs.remote_getOne(Number(organizationID)).then((organization) => {
      setOrganization(organization);
    });
  }
  useEffect(() => {
    if (organizationID) {
      fetchData();
    }
  }, [organizationID]);
  const [nMember, setNMember] = useState(0);
  const [maxMember, setMaxMember] = useState(5);
  const percent = Math.round((nMember / maxMember) * 100);
  const status = percent > 70 ? 'exception' : 'success';
  const [members, setMembers] = useState<any[]>(organization?.memberWithRoles || []);
  const [deletingUserId, setDeletingUserId] = useState<string | null>(null);

  useEffect(() => {
    if (organization?.memberWithRoles) {
      setMembers(organization.memberWithRoles);
      setNMember(organization.memberWithRoles.length);
    }
    if (organization?.maxNMembers) {
      setMaxMember(organization.maxNMembers);
    }
  }, [organization]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleRemoveMember = async (userDocumentId: string) => {
    if (!organizationID || !organization?.documentId) return;
    try {
      setDeletingUserId(userDocumentId);
      await OrganizationAPIs.remote_removeMember(organization.documentId, userDocumentId);
      message.success('Xóa thành viên thành công');
      fetchData();
    } catch (error) {
      console.error('Error removing member:', error);
      message.error('Xóa thành viên thất bại');
    } finally {
      setDeletingUserId(null);
    }
  };

  const columns: ColumnsType<any> = [
    {
      title: <RxAvatar style={{ width: '24px', height: '24px' }} />,
      dataIndex: 'user',
      key: 'user',
      render: (text: any, record: any) => (
        <div>
          <UserAvatar user={record.user} />
        </div>
      ),
    },
    {
      title: 'Số điện thoại',
      dataIndex: 'user',
      key: 'user',
      render: (text: any, record: any) => (
        <div>
          {record.user?.username}
        </div>
      ),
    },
    {
      title: 'Email',
      dataIndex: 'user',
      key: 'user',
      render: (text: any, record: any) => (
        <div>
          {record.user?.email}
        </div>
      ),
    },
    {
      title: 'Vai trò',
      dataIndex: 'role',
      key: 'role',
      render: (text: any, record: any) => (
        <OrganizationRoleTag role={record.role} />
      ),
    },
    {
      title: 'Công cụ',
      dataIndex: 'action',
      key: 'action',
      render: (text: any, record: any) => (
        <div>
          <Popover
            content={
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                <div>Bạn có chắc muốn xóa thành viên này?</div>
                <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                  <Button size="small">Hủy</Button>
                  <Button
                    size="small"
                    type="primary"
                    danger
                    loading={deletingUserId === record.user?.documentId}
                    onClick={() => handleRemoveMember(record.user?.documentId)}
                  >
                    Xóa
                  </Button>
                </div>
              </div>
            }
            title="Xác nhận xóa"
            trigger="click"
          >
            <Button
              type="primary"
              danger
              style={{ padding: 2, width: 30 }}
              loading={deletingUserId === record.user?.documentId}
            >
              <FaTrash size={12} />
            </Button>
          </Popover>
        </div>
      ),
    },
  ];

  return (
    <div>
      <UI_Title>Quản lý nhân viên</UI_Title>
      <Modal
        title="Thêm nhân viên"
        closable={{ 'aria-label': 'Custom Close Button' }}
        open={isModalOpen}
        footer={null}
        onCancel={() => setIsModalOpen(false)}
        onClose={() => setIsModalOpen(false)}
      >
        <FormInviteMember callbackSuccess={() => { setIsModalOpen(false); fetchData() }} />
      </Modal>


      <div style={{ display: 'flex', alignItems: 'center', padding: 8, marginBottom: 16, backgroundColor: '#fff', borderRadius: 8, marginTop: 16 }}>
        <span>Số nhân viên: </span>
        <Progress percent={percent} status={status} style={{ width: '200px', marginLeft: 8 }} />
        <span style={{ marginLeft: 8 }}>{nMember}/{maxMember}</span>
        <div style={{ flex: 1 }}></div>
        <Button type="primary" onClick={() => setIsModalOpen(true)}>Thêm nhân viên</Button>
      </div>

      {/* <div>
        <UI_Table style={{ width: '100%', backgroundColor: '#fff' }}>
          <thead>
            <tr>
              <th style={{ width: '50px' }}>
                <RxAvatar style={{ width: '32px', height: '32px' }} />
              </th>
              <th style={{ width: '200px' }}>Người dùng</th>
              <th>Hoạt động</th>
              <th>Quyền</th>
              <th>Vai trò</th>
            </tr>
          </thead>
          <tbody>
            {members.length > 0 ? (
              members.map((member, index) => (
                <tr key={index}>
                  <td style={{ width: '50px' }}>
                    {member.user?.avatar ? (
                      <img
                        src={(member.user.avatar as StrapiImage)?.previewUrl}
                        alt="avatar"
                        style={{ width: '40px', height: '40px', borderRadius: '50%' }}
                      />
                    ) : (
                      <RxAvatar style={{ width: '40px', height: '40px' }} />
                    )}
                  </td>
                  <td style={{ textAlign: 'left', paddingLeft: '16px' }}>
                    <div>{member.user?.fullname || member.user?.email || 'Người dùng'}</div>
                    <div style={{ fontSize: '12px', color: '#666' }}>{member.user?.email}</div>
                  </td>
                  <td style={{ textAlign: 'center' }}>-</td>
                  <td style={{ textAlign: 'center' }}>
                    <div style={{ cursor: 'pointer' }}>
                      {member.role} <LuChevronDown />
                    </div>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <div style={{ cursor: 'pointer' }}>
                      {member.role} <LuChevronDown />
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5} style={{ textAlign: 'center', padding: '16px', color: '#999' }}>
                  Chưa có thành viên nào trong doanh nghiệp
                </td>
              </tr>
            )}
          </tbody>
        </UI_Table>
      </div> */}

      <Table columns={columns} dataSource={members} style={{ marginBottom: 16 }} />

      <OrgInvitationList organizationID={organizationID} />
    </div >
  )
}

export default memo(OrgMemberList);

const UI_Title = styled.div`
  display: flex;
  align-items: center;
  text-transform: uppercase;
  font-size: 16px;
  font-weight: bold;
`

const UI_Table = styled.table`
  border-collapse: collapse;

  th {
    border-bottom: 1px solid #ccc;
    padding: 4px;
    font-weight: normal;
    font-size: 14px;
  }

  td {
    padding: 8px;
    font-size: 14px;
  }
`;
